import { SessionLayer } from "../../interfaces";
import { getAppBFFUrl } from "../functions";
import { formatData, handleError, handleStepSuccessEvent } from "./api";

export const sendMultiplePrescriptions = async (data: SessionLayer, requestConditions: any) => {
  const { lead_data, push_data, marketing_data } = data;
  const { is_last_step, hasSuccessStep, defaultSuccessPageUrl, successPageRules } = requestConditions;
  const formattedData = await formatData(lead_data, push_data, marketing_data, is_last_step, true);
  const baseUrl = await getAppBFFUrl();

  const requestBody = new FormData();
  formattedData.forEach((value: FormDataEntryValue, key: string) => {
    requestBody.append(key, value);
  });

  try {
    const res = await fetch(
      `${baseUrl}/platform-nexus/public/v2/prescriptions/batch`,
      {
        method: 'POST',
        body: requestBody,
      },
    );
    // Read the body before reporting success: a 2xx without a JSON body (email/send answers 204)
    // is still a success, and must not turn into a retry that duplicates the lead.
    const responseData = await res.json().catch(() => null);
    await handleStepSuccessEvent(res, is_last_step, hasSuccessStep, defaultSuccessPageUrl, successPageRules);

    return {res, details: responseData?.detail}
  } catch (error) {
    return handleError(error);
  }
}